<template>
    
    <commonIndex :tjType="1"/>
  
</template>
           
<script>
import commonIndex from '../commonIndex.vue'
export default {
  components:{
    commonIndex
  }          
}
</script>
<style scoped>
            
</style>